import { z } from 'zod';

// TODO: use the same schema as in libs/contract/backend-dataplane/src/schemas/wsi/ai-handler-result.ts
export const xyCoordinates = z.tuple([z.number().describe('x'), z.number().describe('y')]);

export const patch = z.object({
  coord: xyCoordinates,
  magnification: z.number().nonnegative(),
  /**
   * @deprecated this field will be removed because not used in SlideScanGeneratedMetadataType
   */
  path: z
    .string()
    .regex(/patch_[1-5].png$/, 'The path of the file should be patch_X.png with X belonging to [1, 5]')
    .optional(),
  score: z.number().gte(0).lte(100),
});

/**
 * @deprecated use MetadataPatchType instead.
 */
export type Patch = z.infer<typeof patch>;

/**
 * @deprecated used by the frontend for the AI handler result v2.0.0
 * Should be removed once the frontend is updated to use the new schema.
 */
export const aiContour = z.object({
  area: z.number().describe('Area of the contour'),
  contour: z.array(xyCoordinates).describe('Coordinates forming the contour'),
  hierarchy: z.array(z.number()).min(4).max(4),
});

/**
 * @deprecated use GeoJSONContourType / SlideScanGeneratedMetadata instead.
 */
export type AIContourType = z.infer<typeof aiContour>;

export const GeoJSONContour = z.object({
  type: z.literal('Feature'),
  geometry: z.object({
    type: z.literal('Polygon'),
    coordinates: z.array(z.array(xyCoordinates)),
  }),
}).describe('GeoJSON contour format');

export type GeoJSONContourType = z.infer<typeof GeoJSONContour>;

export const metadataPatch = z.object({
  coord: xyCoordinates,
  magnification: z.number().nonnegative(),
  score: z.number().gte(0).lte(100),
});

export type MetadataPatchType = z.infer<typeof metadataPatch>;

export const SlideScanGeneratedMetadata = z.object({
  schema_version: z.literal('1.0.0').describe('Version of the "slide-scan-generated-metadata.json" schema'),
  contours: z.object({
    blur: z.array(GeoJSONContour).optional(),
    cut_off_tissue_macro: z.array(GeoJSONContour).optional(),
    cut_off_tissue_wsi: z.array(GeoJSONContour).optional(),
    marker_on_top_of_tissue: z.array(GeoJSONContour).optional(),
    missing_tissue: z.array(GeoJSONContour).optional(),
    misaligned_cover_slip: z.array(GeoJSONContour).optional(),
    tissue: z.array(GeoJSONContour).optional(),
  }),
  missing_tissue_bounding_box: z.array(GeoJSONContour).optional(),
  patches: z.object({
    blur: z.array(metadataPatch).optional(),
  }),
}).describe('Metadata about a slide scan generated by the ai handler and the cloud tailored for the frontend');

export type SlideScanGeneratedMetadataType = z.infer<typeof SlideScanGeneratedMetadata>;
